module.exports = __webpack_public_path__ + "static/media/home_laraki.d2e7a619.png";